// src/plugins/axios.js
import axios from 'axios';
import store from '../store'; // 引入 Vuex store
import {Message} from 'element-ui';
const instance = axios.create({
    baseURL: 'https://devsdk.txitech.com/api', // 替换为你的 API 基础 URL
    timeout: 1000, // 设置请求超时时间
    headers: {'X-Custom-Header': 'foobar'}
});

// 设置请求拦截器
instance.interceptors.request.use(config => {
    // 在请求头中添加Authorization字段
    let access_token=store.getters.getUserParams('access_token')
    if (access_token){
        config.headers.Authorization = `Bearer ${access_token}`;
    }
    return config;
}, error => {
    return Promise.reject(error);
});

// 添加响应拦截器
instance.interceptors.response.use(function (response) {
    // 2xx 范围内的状态码都会触发该函数。
    // 对响应数据做点什么
    return response;
}, function (error) {
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    if (error.response){
        Message({
            message: error.response.statusText,
            duration:1000,
            center: true
        });
    }
    localStorage.removeItem("userInfo");
    return Promise.reject(error);
});

export default instance;
